import { Text } from '@cinch-labs/design-system'
import {
  VapsFaqItem,
  VapsFaqSection,
  storyblokEditable,
} from '@cinch-nx/data-storyblok'

import Accordion from '../accordion/accordion.component'
import renderWithResolver from '../rich-text-renderer/rich-text-renderer'
import styles from './faq-accordion.module.css'

export const FaqAccordion: React.FC<VapsFaqSection> = (blok) => {
  const { title, faqs } = blok

  const accordionItems = faqs.map((faq: VapsFaqItem) => ({
    title: faq.title,
    children: () => <>{renderWithResolver(faq.body)}</>,
  }))

  return (
    <section className={styles.faqSection} {...storyblokEditable(blok)}>
      <Text className={styles.sectionTitle} element="h2" fontWeight="bold">
        {title}
      </Text>
      <Accordion
        title={title}
        items={accordionItems}
        buttonId="model-faq-button"
        sectionId="model-faq-section"
      />
    </section>
  )
}

export default FaqAccordion
